/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");



// editPos: 9999 - bulk editing, +n - adding at position n, -n - deleting at position n
function editPos(prev, curr) {
  if (Math.abs(prev.length - curr.length) !== 1) {
    // user is editing multiple chars
    return 9999;
  }

  let l = prev;
  let s = curr;
  let adding = -1;
  if (s.length > l.length) {
    [l, s] = [s, l];
    adding = 1;
  }

  let index = 9999;
  _.forEach(_.range(l.length), (idx) => {
    if (`${l.substr(0, idx)}${l.substr(idx + 1)}` === s) {
      index = idx;
    }
  });
  return index * adding;
}

function formatIdInput(fullPairs = []) {
  if (fullPairs.length === 0) {
    return curr => curr;
  }

  const fullLens = fullPairs.map(p => p * 2);
  const fullTrailings = fullLens.map(l => ((l + (l / 2)) - 1));
  const breakPoints = _.range(0, _.max(fullLens), 2);

  return (curr, prev = '') => {
    let id = curr.replace(':', '-').replace(/[^0-9a-fA-F-]/g, '');

    if (`${curr}-` === prev) {
      // use is deleting the trailing '-'
      if (!fullTrailings.includes(id.length)) {
        id = id.substr(0, id.length - 1);
      }
      return id;
    }

    const ep = editPos(prev, curr);

    if (ep === 9999) {
      // just reformat
      let postfix = id[id.length - 1] === '-';
      id = id.replace(/[^0-9a-fA-F]/g, '');

      const fullMac = (m) => {
        const nsm = m.replace(/[^0-9a-fA-F]/g, '');
        return fullLens.includes(nsm.length);
      };

      if (!fullMac(id) &&
          id.length % 2 === 0 &&
          id.length > 0) {
        postfix = true;
      }

      id = breakPoints
        .slice(0, Math.ceil(id.length / 2))
        .map(i => id.substr(i, 2)).join('-');
      if (postfix) {
        id += '-';
      }
    } else if (ep === id.length - 1) {
      // add trailing '-'
      if (id[id.length - 1] === '-') {
        return id.replace(/-+$/, '-');
      }
      // adding trailing paired alphabet
      if (/[0-9a-fA-F]{3}$/.test(id)) {
        return `${id.substr(0, id.length - 1)}-${id[id.length - 1]}`;
      }
      const fullPair = (m) => {
        const pairs = m.split('-').length;
        return fullPairs.includes(pairs);
      };
      if (/[0-9a-fA-F]{2}$/.test(id) && !fullPair(id)) {
        return `${id}-`;
      }
    }

    return id;
  };
}

function normalizeId(fullPairs = []) {
  if (fullPairs.length === 0) {
    return () => false;
  }

  const fullLens = fullPairs.map(p => p * 2);
  const breakPoints = _.range(0, _.max(fullLens), 2);

  return (id) => {
    let nid = id.toUpperCase();
    if (nid.indexOf(':') !== -1 || nid.indexOf('-') !== -1) {
      nid = nid.split(/[:-]/).join('');
    }
    return breakPoints
      .slice(0, Math.ceil(nid.length / 2))
      .map(i => nid.substr(i, 2)).join('-');
  };
}

function isValidId(fullPairs = []) {
  if (fullPairs.length === 0) {
    return () => false;
  }

  const regexs = [];
  fullPairs.forEach((p) => {
    regexs.push(new RegExp(`^([0-9A-F]{2}-){${p - 1}}[0-9A-F]{2}$`));
    regexs.push(new RegExp(`^([0-9A-F]{2}:){${p - 1}}[0-9A-F]{2}$`));
    regexs.push(new RegExp(`^([0-9A-F]{2}){${p - 1}}[0-9A-F]{2}$`));
  });

  return (id) => {
    const nid = id.toUpperCase();
    return _.some(regexs, reg => reg.test(nid));
  };
}


// ========================
//       MAC Addresses
// ========================

export const formatMacInput = formatIdInput([6, 8]);

export function normalizeMac(id) {
  let nid = id.toUpperCase();
  if (nid.indexOf(':') !== -1 || nid.indexOf('-') !== -1) {
    nid = nid.split(/[:-]/).join('');
  }
  if (nid.length === 12) {
    nid = `${nid.slice(0, 6)}FFFE${nid.slice(6, 12)}`;
  }
  return [0, 2, 4, 6, 8, 10, 12, 14].map(i => nid.substr(i, 2)).join('-');
}

export const isValidMac = isValidId([6, 8]);


// ========================
//         AppEUI
// ========================

export const formatAppEUIInput = formatIdInput([8]);
export const normalizeAppEUI = normalizeId([8]);
export const isValidAppEUI = isValidId([8]);


// ========================
//         DevEUI
// ========================

export const formatDevEUIInput = formatIdInput([8]);
export const normalizeDevEUI = normalizeId([8]);
export const isValidDevEUI = isValidId([8]);


// ========================
//         DevAddr
// ========================

export const formatDevAddrInput = formatIdInput([4]);
export const normalizeDevAddr = normalizeId([4]);
export const isValidDevAddr = isValidId([4]);




// WEBPACK FOOTER //
// ./src/utils/IdUtils.js